module.exports = __webpack_public_path__ + "static/media/zw.474fd038.png";